if (!window.edPinfoLoaded) {
window.edPinfoLoaded = true;

class ProductInformation extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.querySelector("pinfo-variant-picker")?.addEventListener(
      "input",
      this.handleVariantEvent.bind(this)
    );
    this.initQuantitySelector();
    this.initMobileSwiper();
    this.bindFormSubmit();
    this.bindBuyNow();
  }

  get productJSON() {
    if (!this._productJSON) {
      const el = this.querySelector('script[data-product-json]');
      this._productJSON = el ? JSON.parse(el.textContent) : null;
    }
    return this._productJSON;
  }

  get mediaOrder() {
    if (!this._mediaOrder) {
      this._mediaOrder = Array.from(
        this.querySelectorAll('.main-swiper .swiper-slide')
      ).map(s => s.dataset.media);
    }
    return this._mediaOrder;
  }

  handleVariantEvent(e) {
    const { variantUrl } = e.target.dataset;
    this.handleOptions(variantUrl);
    const params = new URLSearchParams(variantUrl.split('?')[1]);
    const variantId = Number(params.get('variant'));
    if (variantId) this.slideToVariantMedia(variantId);
  }

  slideToVariantMedia(variantId) {
    const product = this.productJSON;
    if (!product) return;
    const variant = product.variants.find(v => v.id === variantId);
    if (!variant || !variant.featured_media) return;
    const mediaId = String(variant.featured_media.id);
    const idx = this.mediaOrder.indexOf(mediaId);
    if (idx > -1 && this.mobileSwiper) this.mobileSwiper.slideTo(idx, 300);
  }

  initQuantitySelector() {
    const wrapper = this.querySelector('[data-quantity-selector]');
    if (!wrapper) return;
    const input = wrapper.querySelector('.qty-input');
    const dec = wrapper.querySelector('.decrease');
    const inc = wrapper.querySelector('.increase');
    const update = () => this.dispatchQuantityChange(input.value);
    dec?.addEventListener('click', () => {
      let v = parseInt(input.value) || 1;
      if (v > (input.min || 1)) { input.value = v - 1; update(); }
    });
    inc?.addEventListener('click', () => {
      input.value = (parseInt(input.value) || 1) + 1;
      update();
    });
    input?.addEventListener('input', () => {
      if (input.value < 1) input.value = 1;
      update();
    });
  }

  dispatchQuantityChange(value) {
    this.dispatchEvent(new CustomEvent('quantity-change', {
      detail: { quantity: Number(value) },
      bubbles: true
    }));
  }

  initMobileSwiper() {
    const container = this.querySelector('.pdp-media-container');
    if (!container) return;
    const mainEl = container.querySelector('.main-swiper');
    const thumbEl = container.querySelector('.thumb-swiper');
    if (!mainEl || !thumbEl) return;
    this.thumbSwiper = new Swiper(thumbEl, {
      slidesPerView: "auto",
      spaceBetween: 10,
      watchSlidesProgress: true,
      freeMode: true,
      breakpoints: {
        989: { direction: "vertical" }
      }
    });
    this.mobileSwiper = new Swiper(mainEl, {
      thumbs: { swiper: this.thumbSwiper },
      loop: false
    });
  }

  bindFormSubmit() {
    const form = this.querySelector('form[action$="/cart/add"]');
    if (!form) return;
    form.removeEventListener('submit', this.handleAddToCart);
    form.addEventListener('submit', this.handleAddToCart);
  }

  bindBuyNow() {
    const btn = this.querySelector('.p-info-btn-buy-now');
    if (!btn) return;
    btn.removeEventListener('click', this.handleBuyNow);
    btn.addEventListener('click', this.handleBuyNow);
  }

  handleBuyNow = async (e) => {
    e.preventDefault();
    const btn = e.currentTarget;
    const form = this.querySelector('form[action$="/cart/add"]');
    if (!form) return;

    btn.disabled = true;
    btn.textContent = 'Processing...';

    const data = new FormData(form);
    const qty = this.querySelector('.qty-input');
    if (qty) data.set('quantity', qty.value);

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        body: data
      });
      window.location.href = '/checkout';
    } catch (err) {
      console.error('Buy Now failed:', err);
      btn.textContent = 'Try Again';
      btn.disabled = false;
    }
  }

  handleOptions(url) {
    this.fetchData(url);
    this.updateURL(url);
  }

  async fetchData(url) {
    const sectionUrl = `${url}&section_id=${this.sectionId}`;
    const resp = await fetch(sectionUrl);
    const txt = await resp.text();
    const html = new DOMParser().parseFromString(txt, 'text/html');
    this.renderEl(html);
  }

  renderEl(html) {
    this.querySelectorAll('pinfo-variant-picker').forEach((el, i) => {
      const newEl = html.querySelectorAll('pinfo-variant-picker')[i];
      if (newEl) el.innerHTML = newEl.innerHTML;
    });
    this.querySelectorAll('.pinfo-price-wrapper').forEach((el, i) => {
      const newEl = html.querySelectorAll('.pinfo-price-wrapper')[i];
      if (newEl) el.innerHTML = newEl.innerHTML;
    });
    this.querySelectorAll('.pinfo-form-wrapper').forEach((el, i) => {
      const newEl = html.querySelectorAll('.pinfo-form-wrapper')[i];
      if (newEl) {
        el.innerHTML = newEl.innerHTML;
        this.bindFormSubmit();
        this.bindBuyNow();
      }
    });
    const idInput = this.querySelector('input[name="id"]');
    if (idInput?.value) {
      const vid = Number(idInput.value);
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: vid } }));
      this.slideToVariantMedia(vid);
    }
  }

  updateURL(url) {
    if (typeof url !== 'string' || !url.startsWith('/')) return;
    if (this.dataset?.updateUrl === 'true') {
      window.history.pushState({}, '', url);
    }
  }

  handleAddToCart = (e) => {
    e.preventDefault();
    const btn = this.querySelector('button[type="submit"]');
    if (btn) {
      btn.textContent = 'Adding To Cart ...';
      btn.disabled = true;
      btn.style.opacity = '0.7';
    }
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const form = this.querySelector('form[action$="/cart/add"]');
    const data = new FormData(form);
    const qty = this.querySelector('.qty-input');
    if (qty) data.set('quantity', qty.value);
    if (this.cart) data.append('sections', this.cart.getSectionsToRender().map(s => s.id));
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: data
    })
      .then(r => r.json())
      .then(res => { if (this.cart) this.cart.renderContents(res); })
      .finally(() => {
        if (btn) {
          btn.textContent = 'Add To Cart';
          btn.disabled = false;
          btn.style.opacity = '1';
        }
        if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        this.closest('.pqv-wrapper')?.querySelector('.pqv-close-btn')?.click();
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('product-information')) {
    customElements.define('product-information', ProductInformation);
  }
});

}